@if (shouldShow) {
  <section class="h-screen w-screen fixed left-0 top-0 px-4 pt-6 pb-4 lg:pt-12 bg-[#21333F]/20 z-[60] flex justify-center" (click)="onBackdropClick($event)">
    <section class="max-w-[842px] bg-white px-6 pt-12 pb-8 rounded-lg flex flex-col gap-6 w-full relative overflow-y-auto max-h-[665px]" (click)="$event.stopPropagation()">
      <button (click)="closeSchedule($event, '')" class="absolute top-4 right-4 w-6 h-6">
        <fa-icon [icon]="faX" class="text-vis-subtle"></fa-icon>
      </button>
      <section class="grid gap-2">
        <!-- TODO: Add brand decoder for pre-license -->
        <h3 class="text-lg font-extrabold text-vis-dark mb-0">{{title}}</h3>
        <div class="wysiwyg text-base font-normal text-vis-subtle" [innerHTML]="description"></div>
      </section>
      @if (hasScheduleData) {
        <p class="text-base font-extrabold text-vis-dark">{{upcomingLabel}}</p>
        <section class="grid overflow-y-auto">
          <!-- Template Outlet -->
          <ng-container *ngTemplateOutlet="layout"></ng-container>
        </section>
      } @else {
        <p class="text-base text-vis-subtle">No webinars available at this time.</p>
      }
    </section>
  </section>
}

<ng-template #BrokerPreLicenseTpl>
  <section class="grid">
    @for (course of webinarSchedule; track course; let i = $index) {
      <div>
        @for (session of course.sessionList; track session) {
          <details class="py-5 border-t border-vis-muted last:border-b" (toggle)="toggleDetails($event, i)">
            <summary class="flex items-center justify-between cursor-pointer title">
              <p class="text-base text-vis-dark font-semibold">{{ session.title }}</p>
              <fa-icon [icon]="faAngleDown" class="text-vis-subtle" [ngClass]="{'rotate-180': openSessions[i]}"></fa-icon>
            </summary>
            <ul class="grid mt-4">
              @for (event of session.eventsList; track event) {
                <li class="flex justify-between py-[6px] last:py-0 first:pt-0">
                  <p class="text-base text-vis-subtle">{{ event.day }}</p>
                  <p class="text-base text-vis-subtle">{{ event.time }}</p>
                </li>
              }
            </ul>
          </details>
        }
      </div>
    }
  </section>
</ng-template>

<ng-template #ManagingBrokerPreLicenseTpl>
  <section class="grid">
    @for (course of webinarSchedule; track course; let i = $index) {
      <div>
        @for (session of course.sessionList; track session) {
          <details class="py-5 border-t border-vis-muted last:border-b" (toggle)="toggleDetails($event, i)">
            <summary class="flex items-center justify-between cursor-pointer title">
              <p class="text-base text-vis-dark font-semibold">{{ session.title }}</p>
              <fa-icon [icon]="faAngleDown" class="text-vis-subtle" [ngClass]="{'rotate-180': openSessions[i]}"></fa-icon>
            </summary>
            <ul class="grid mt-4">
              @for (event of session.eventsList; track event) {
                <li class="flex justify-between py-[6px] last:py-0 first:pt-0">
                  <p class="text-base text-vis-subtle">{{ event.day }}</p>
                  <p class="text-base text-vis-subtle">{{ event.time }}</p>
                </li>
              }
            </ul>
          </details>
        }
      </div>
    }
  </section>
</ng-template>

<ng-template #REContinuingEdTpl>
  @for (course of webinarSchedule; track course; let i = $index) {
    <div class="border-vis-muted first:border-t border-b">
      @for (session of course.sessionList; track session) {
        <details class="py-5" (toggle)="toggleDetails($event, i)">
          <summary class="flex items-center justify-between cursor-pointer title">
            <p class="text-base text-vis-dark font-semibold">{{ session.title }}</p>
            <fa-icon [icon]="faAngleDown" class="text-vis-subtle" [ngClass]="{'rotate-180': openSessions[i]}"></fa-icon>
          </summary>
          <!-- Group events by eventId -->
          @if (getGroupedEvents(session); as grouped) {
            @for (eventId of getGroupedEventKeys(grouped); track eventId; let groupIndex = $index) {
              <div class="mt-4 mb-3 last:mb-0">
                <ul class="grid gap-1.5 py-2">
                  @for (eventWithDay of formatGroupedEventWithDays(grouped[eventId]); track eventWithDay) {
                    <li class="flex justify-between">
                      <p class="text-base text-vis-subtle">{{ eventWithDay.day }}</p>
                      <p class="text-base text-vis-subtle">{{ eventWithDay.time }}</p>
                    </li>
                  }
                </ul>
              </div>
            }
          }
        </details>
      }
    </div>
  }
</ng-template>

<ng-template #ResidentialLeasingAgentPreLicenseTpl>
  <section class="grid">
    @for (course of webinarSchedule; track course; let i = $index) {
      <section class="pb-5">
        <p class="text-base text-vis-dark font-semibold">{{ course.title }}</p>
        <div class="mt-4">
          <!-- Group events by eventId -->
          @for (eventId of getGroupedEventKeys(getGroupedEvents(course.sessionList[0])); track eventId; let groupIndex = $index) {
            <div class="border-b border-vis-muted first:border-t">
              @for (groupedEvents of [getGroupedEvents(course.sessionList[0])[eventId]]; track groupedEvents) {
                <div class="p-3 mb-3">
                  <ul class="grid">
                    @for (eventWithDay of formatGroupedEventWithDays(groupedEvents); track eventWithDay) {
                      <li class="flex justify-between py-[6px]">
                        <p class="text-base text-vis-subtle">
                          <span class="font-bold">{{ eventWithDay.dayLabel }}:</span>
                          {{ eventWithDay.day }}
                        </p>
                        <p class="text-base text-vis-subtle">{{ eventWithDay.time }}</p>
                      </li>
                    }
                  </ul>
                </div>
              }
            </div>
          }
        </div>
      </section>
    }
  </section>
</ng-template>

<ng-template #MTGPreLicenseTpl>
  <section class="grid">
    @for (course of webinarSchedule; track course; let i = $index) {
      <section class="pb-5">
        <p class="text-base text-vis-dark font-semibold">{{ course.title }}</p>
        <div class="mt-4">
          <!-- Group events by eventId -->
          @for (eventId of getGroupedEventKeys(getGroupedEvents(course.sessionList[0])); track eventId; let groupIndex = $index) {
            <div class="border-b border-vis-muted first:border-t">
              @for (groupedEvents of [getGroupedEvents(course.sessionList[0])[eventId]]; track groupedEvents) {
                <div class="p-3 mb-3">
                  <ul class="grid">
                    @for (eventWithDay of formatGroupedEventWithDays(groupedEvents); track eventWithDay) {
                      <li class="flex justify-between py-[6px]">
                        <p class="text-base text-vis-subtle">
                          <span class="font-bold">{{ eventWithDay.dayLabel }}:</span>
                          {{ eventWithDay.day }}
                        </p>
                        <p class="text-base text-vis-subtle">{{ eventWithDay.time }}</p>
                      </li>
                    }
                  </ul>
                </div>
              }
            </div>
          }
        </div>
      </section>
    }
  </section>
</ng-template>

<ng-template #INSPreLicenseTpl>
  @for (course of webinarSchedule; track course; let i = $index) {
    <div class="border-vis-muted first:border-t border-b">
      @for (session of course.sessionList; track session) {
        <details class="py-5" (toggle)="toggleDetails($event, i)">
          <summary class="flex items-center justify-between cursor-pointer title gap-2">
            <section>
              <p class="text-base text-vis-dark font-semibold">{{ session.title }}</p>
            </section>
            <fa-icon [icon]="faAngleDown" class="text-vis-subtle" [ngClass]="{'rotate-180': openSessions[i]}"></fa-icon>
          </summary>
          <ul class="grid mt-4 gap-1.5">
            @for (event of session.eventsList; track event) {
              <li class="flex justify-between">
                <p class="text-base text-vis-subtle">{{ event.day }}</p>
                <p class="text-base text-vis-subtle">{{ event.time }}</p>
              </li>
            }
          </ul>
        </details>
      }
    </div>
  }
</ng-template>

<ng-template #INSContinuingEdTpl>
  @for (course of webinarSchedule; track course; let i = $index) {
    <section>
      <p class="text-base text-vis-dark font-semibold">{{ course.title }}</p>
      <ul class="grid gap-x-8 md:grid-cols-2 md:grid-rows-4 mt-4 md:grid-flow-col">
        @for (event of course.sessionList[0].eventsList; track event; let day = $index) {
          <li class="flex justify-between py-4 border-vis-muted border-t md:[&:nth-child(4)]:border-b last:border-b">
            <p class="text-base text-vis-subtle">{{ event.day }}</p>
            <p class="text-base text-vis-subtle">{{ event.time }}</p>
          </li>
        }
      </ul>
    </section>
  }
</ng-template>

<ng-template #MTGContinuingEdTpl>
  @for (course of webinarSchedule; track course; let i = $index) {
    <section>
      <ul class="grid grid-flow-col gap-x-8 lg:grid-cols-2 lg:grid-rows-4 mt-4">
        @for (event of course.sessionList[0].eventsList; track event; let day = $index) {
          <li class="flex justify-between py-4 border-t border-vis-muted last:border-b">
            <p class="text-base text-vis-subtle">{{ event.day }}</p>
            <p class="text-base text-vis-subtle">{{ event.time }}</p>
          </li>
        }
      </ul>
    </section>
  }
</ng-template>
